import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { BASE_API_URL } from "../const";

const MainFilter = ({
  responseFilter,
  setSendDataFilmListQueryFilter,
  getDataFilmList,
  manageBlock,
}) => {
  // Состояния для каждого Select
  const [selectedFormat, setSelectedFormat] = useState("");
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState([]);
  const [selectedLastShow, setSelectedLastShow] = useState("");
  const [selectedSerial, setSelectedSerial] = useState("");
  const [selectedRate, setSelectedRate] = useState("");
  const [selectedVote, setSelectedVote] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedPreset, setSelectedPreset] = useState("");
  const [selectedBundle, setSelectedBundle] = useState("");
  const [textFilter, setTextFilter] = useState("");
  const [textId, setTextId] = useState(""); // ← Новое состояние для ID фильма

  const [excludeCountry, setExcludeCountry] = useState(false);
  const [excludeGenre, setExcludeGenre] = useState(false);

  // Массив данных для селектов
  const selectFormat = [];
  const selectCountry = [];
  const selectGenre = [];
  const selectLastShow = [];
  const selectRate = [];
  const selectVote = [];
  const selectYear = [];
  const selectPreset = [];
  const selectBundle = [];

  // Массив данных для отправки в API
  const [sendFilterToAPI, setSendFilterToAPI] = useState("");
  const [filters, setFilters] = useState({
    format: "",
    country: "",
    genre: "",
    last_show: "",
    serial: null,
    rate: "",
    vote: "",
    year: "",
    query: "",
    id: "", // ← Добавлено
    CountryBlackList: false,
    GenreBlackList: false,
    preset: "",
    BundleBlackList: false,
  });

  const updateFilter = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));

    setSendFilterToAPI(() => {
      const updatedFilters = {
        ...filters,
        [key]: value,
      };

      const filterString = Object.keys(updatedFilters)
        .filter((filterKey) =>
          filterKey === "serial"
            ? updatedFilters[filterKey] !== null
            : updatedFilters[filterKey]
        )
        .map((filterKey) => `${filterKey}=${updatedFilters[filterKey]}`)
        .join("&");

      return filterString ? `&${filterString}` : "";
    });
  };

  // === ВЕБСОКЕТ (используем https напрямую, как сказал бэк) ===
  const wsRef = useRef(null);

  useEffect(() => {
    const wsUrl = `${BASE_API_URL}/notify`;

    console.log("Попытка подключения WebSocket к:", wsUrl);

    const socket = new WebSocket(wsUrl);
    wsRef.current = socket;

    socket.onopen = () => {
      console.log("✅ WebSocket успешно подключён");
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("📨 WebSocket сообщение:", data);
      } catch (err) {
        console.log("📨 WebSocket raw данные:", event.data);
      }
    };

    socket.onerror = (error) => {
      console.error("❌ WebSocket ошибка соединения:", error);
    };

    socket.onclose = (event) => {
      console.log(
        `🔌 WebSocket закрыт. Код: ${event.code}, причина: ${
          event.reason || "нет причины"
        }`
      );
    };

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, []);

  // Заполняем массивы данными
  if (responseFilter.format) {
    responseFilter.format.map((element) => {
      selectFormat.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.country) {
    responseFilter.country.map((element) => {
      selectCountry.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.genre) {
    responseFilter.genre.map((element) => {
      selectGenre.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.last_show) {
    responseFilter.last_show.map((element) => {
      selectLastShow.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.rate) {
    responseFilter.rate.map((element) => {
      selectRate.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.vote) {
    responseFilter.vote.map((element) => {
      selectVote.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.year) {
    responseFilter.year.map((element) => {
      selectYear.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.preset) {
    responseFilter.preset.map((element) => {
      selectPreset.push({ value: element.id, label: element.name });
    });
  }
  if (responseFilter.bundle) {
    responseFilter.bundle.map((element) => {
      selectBundle.push({ value: element.id, label: element.name });
    });
  }

  // Обработчики изменений для каждого Select
  const handleChangeFormat = (e) => {
    const value = e.target.value;
    const format = value === "" ? "" : selectedFormat === value ? "" : value;

    setSelectedFormat(format);
    updateFilter("format", format);
  };

  const handleChangeCountry = (event) => {
    const value = event.target.value;
    setSelectedCountry(value);
    const joinedValue = value.join("|");
    updateFilter("country", joinedValue);
  };

  const handleChangeGenre = (e) => {
    const value = e.target.value;
    setSelectedGenre(value);
    const joinedValue = value.join("|");
    updateFilter("genre", joinedValue);
  };

  const handleChangeLastShow = (e) => {
    const value = e.target.value;
    const lastShow =
      value === "" ? "" : selectedLastShow === value ? "" : value;
    setSelectedLastShow(lastShow);
    updateFilter("last_show", lastShow);
  };

  const handleChangeSerial = (e) => {
    const value = e.target.value;
    const serial =
      value === "" ? null : selectedSerial === value ? null : value;

    setSelectedSerial(serial === null ? "" : serial);
    updateFilter("serial", serial);
  };

  const handleChangeRate = (e) => {
    const value = e.target.value;
    const newRate = value === "" ? "" : selectedRate === value ? "" : value;

    setSelectedRate(newRate);
    updateFilter("rate", newRate);
  };

  const handleChangeVote = (e) => {
    const value = e.target.value;
    const newVote = value === "" ? "" : selectedVote === value ? "" : value;
    setSelectedVote(newVote);
    updateFilter("vote", newVote);
  };

  const handleChangeYear = (e) => {
    const value = e.target.value;
    const newYears = value === "" ? "" : selectedYear === value ? "" : value;
    setSelectedYear(newYears);
    updateFilter("year", newYears);
  };

  const handleChangePreset = (e) => {
    const value = e.target.value;
    const newPreset = value === "" ? "" : selectedPreset === value ? "" : value;
    setSelectedPreset(newPreset);
    updateFilter("preset", newPreset);
  };

  const handleChangeBundle = (e) => {
    const value = e.target.value;
    const newBundle = value === "" ? "" : selectedBundle === value ? "" : value;
    setSelectedBundle(newBundle);
    updateFilter("bundle", newBundle);
  };

  // Обработчик для Названия/части названия
  const handleQueryChange = (event) => {
    const query = event.target.value;
    setTextFilter(query);
    updateFilter("query", query);
  };

  // Новый обработчик для ID фильма
  const handleIdChange = (event) => {
    const id = event.target.value;
    setTextId(id);
    updateFilter("id", id);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      ButtonOnClick();
    }
  };

  const ButtonOnClick = () => {
    const timestamp = new Date().getTime().toString();
    const updatedFilter = `${sendFilterToAPI}&timestamp=${timestamp}`;
    setSendDataFilmListQueryFilter(updatedFilter);
  };

  const handleClear = () => {
    setTextFilter("");
    setTextId(""); // очищаем ID

    const newFilters = { ...filters, query: "", id: "" };

    setFilters(newFilters);

    const filterString = Object.keys(newFilters)
      .filter((key) =>
        key === "serial" ? newFilters[key] !== null : newFilters[key]
      )
      .map((key) => `${key}=${newFilters[key]}`)
      .join("&");

    const timestamp = Date.now().toString();
    const updatedFilter = `${
      filterString ? "&" + filterString : ""
    }&timestamp=${timestamp}`;

    setSendDataFilmListQueryFilter(updatedFilter);
    setSendFilterToAPI(filterString ? `&${filterString}` : "");
  };

  const handleExcludeCountryChange = (event) => {
    const isChecked = event.target.checked;
    updateFilter("CountryBlackList", isChecked);
  };

  const handleExcludeBundleChange = (event) => {
    const isChecked = event.target.checked;
    updateFilter("BundleBlackList", isChecked);
  };

  const handleExcludeGenreChange = (event) => {
    const isChecked = event.target.checked;
    updateFilter("GenreBlackList", isChecked);
  };

  useEffect(() => {
    if (selectedFormat) {
      updateFilter("format", selectFormat[2]?.value);
    }
  }, []);

  if (manageBlock) return null;

  return (
    <Box
      sx={{
        pt: 0,
        borderBottom: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography
        variant="h6"
        align="center"
        sx={{ lineHeight: 1.1, marginBottom: "2px" }}
      >
        Фильтры
      </Typography>

      {/* Верхний блок с 9 селектами */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-around", gap: 2 }}>
          {/* Формат */}
          <FormControl key={0} sx={{ minWidth: 120 }}>
            <InputLabel
              id="format-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Формат
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="format-select-label"
              id="format-select"
              value={selectedFormat}
              onChange={handleChangeFormat}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectFormat.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Страны */}
          <FormControl key={1} sx={{ minWidth: 120 }}>
            <InputLabel
              id="country-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Страны
            </InputLabel>
            <Select
              multiple
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="country-select-label"
              id="country-select"
              value={selectedCountry}
              onChange={handleChangeCountry}
              renderValue={(selected) => selected.join(", ")}
            >
              {selectCountry.map((option, index) => (
                <MenuItem
                  key={`${option.value}-${index}`}
                  value={option.value}
                  sx={{
                    fontWeight: selectedCountry.includes(option.value)
                      ? "bold"
                      : "normal",
                    backgroundColor: selectedCountry.includes(option.value)
                      ? "#E0E0E0"
                      : "inherit",
                  }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <Box sx={{ mt: 0, textAlign: "center" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filters.CountryBlackList}
                    onChange={handleExcludeCountryChange}
                  />
                }
                label="Исключить страну"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px" } }}
              />
            </Box>
          </FormControl>

          {/* Жанры */}
          <FormControl key={2} sx={{ minWidth: 120 }}>
            <InputLabel
              id="genre-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Жанры
            </InputLabel>
            <Select
              multiple
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="genre-select-label"
              id="genre-select"
              value={selectedGenre}
              onChange={handleChangeGenre}
              renderValue={(selected) => selected.join(", ")}
            >
              {selectGenre.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{
                    fontWeight: selectedGenre.includes(option.value)
                      ? "bold"
                      : "normal",
                    backgroundColor: selectedGenre.includes(option.value)
                      ? "#E0E0E0"
                      : "inherit",
                  }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <Box sx={{ mt: 0, textAlign: "center" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filters.GenreBlackList}
                    onChange={handleExcludeGenreChange}
                  />
                }
                label="Исключить жанр"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px" } }}
              />
            </Box>
          </FormControl>

          {/* Эфир */}
          <Box
            key={3}
            sx={{
              minWidth: 120,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel
                id="lastShow-select-label"
                shrink={true}
                sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
              >
                Эфир
              </InputLabel>
              <Select
                sx={{
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& .MuiSelect-select": { textAlign: "center" },
                }}
                labelId="lastShow-select-label"
                id="lastShow-select"
                value={selectedLastShow}
                onChange={handleChangeLastShow}
              >
                <MenuItem value="">
                  <em>Очистить</em>
                </MenuItem>
                {selectLastShow.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel
                id="serial-select-label"
                shrink={true}
                sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
              >
                Сериал
              </InputLabel>
              <Select
                sx={{
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& .MuiSelect-select": { textAlign: "center" },
                }}
                labelId="serial-select-label"
                id="serial-select"
                value={selectedSerial}
                onChange={handleChangeSerial}
              >
                <MenuItem value="">
                  <em>Очистить</em>
                </MenuItem>
                <MenuItem value={true}>Сериал</MenuItem>
                <MenuItem value={false}>Фильм</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Рейтинг */}
          <FormControl key={4} sx={{ minWidth: 120 }}>
            <InputLabel
              id="rate-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Рейтинг
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="rate-select-label"
              id="rate-select"
              value={selectedRate}
              onChange={handleChangeRate}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectRate.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Голоса */}
          <FormControl key={5} sx={{ minWidth: 120 }}>
            <InputLabel
              id="vote-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Голоса
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="vote-select-label"
              id="vote-select"
              value={selectedVote}
              onChange={handleChangeVote}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectVote.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Года */}
          <FormControl key={6} sx={{ minWidth: 120 }}>
            <InputLabel
              id="year-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Года
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleChangeYear}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectYear.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Пресет */}
          <FormControl key={7} sx={{ minWidth: 120 }}>
            <InputLabel
              id="preset-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Пресет
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="preset-select-label"
              id="preset-select"
              value={selectedPreset}
              onChange={handleChangePreset}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectPreset.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Группировка */}
          <FormControl key={8} sx={{ minWidth: 120 }}>
            <InputLabel
              id="bundle-select-label"
              shrink={true}
              sx={{ fontSize: "12px", textAlign: "center", top: "-6px" }}
            >
              Группировка
            </InputLabel>
            <Select
              sx={{
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSelect-select": { textAlign: "center" },
              }}
              labelId="bundle-select-label"
              id="bundle-select"
              value={selectedBundle}
              onChange={handleChangeBundle}
            >
              <MenuItem value="">
                <em>Очистить</em>
              </MenuItem>
              {selectBundle.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <Box sx={{ mt: 0, textAlign: "center" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filters.BundleBlackList}
                    onChange={handleExcludeBundleChange}
                  />
                }
                label="Исключить группировку"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px" } }}
              />
            </Box>
          </FormControl>
        </Box>
      </Box>

      {/* Блок с текстовыми полями: Название + ID */}
      <Box
        sx={{ display: "flex", justifyContent: "space-between", marginTop: 0 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography variant="body1">Название/часть названия</Typography>
          <TextField
            sx={{ width: "200px" }}
            variant="outlined"
            value={textFilter}
            onChange={handleQueryChange}
            onKeyDown={handleKeyDown}
            autoComplete="off"
            InputProps={{
              sx: {
                height: "30px",
                padding: 0,
                "& input": {
                  padding: "0 8px",
                  height: "20px",
                  fontSize: "14px",
                },
              },
              endAdornment: (textFilter || textId) && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClear}
                    sx={{
                      color: "gray",
                      bgcolor: "rgba(0,0,0,0.1)",
                      borderRadius: "50%",
                      "&:hover": { bgcolor: "rgba(0,0,0,0.2)" },
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Typography variant="body1">ID</Typography>
          <TextField
            sx={{ width: "140px" }}
            variant="outlined"
            value={textId}
            onChange={handleIdChange}
            onKeyDown={handleKeyDown}
            placeholder="12345"
            autoComplete="off"
            InputProps={{
              sx: {
                height: "30px",
                padding: 0,
                "& input": {
                  padding: "0 8px",
                  height: "20px",
                  fontSize: "14px",
                },
              },
              endAdornment: (textFilter || textId) && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClear}
                    sx={{
                      color: "gray",
                      bgcolor: "rgba(0,0,0,0.1)",
                      borderRadius: "50%",
                      "&:hover": { bgcolor: "rgba(0,0,0,0.2)" },
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <Button variant="contained" color="primary" onClick={ButtonOnClick}>
            сформировать
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MainFilter;
